import React, { Component } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import Aadhaar from "../../Images/aadhaarLogo.png";
import Mobile from "../../Images/verification-N.png";
import updateIcon from "../../Images/output.png";
import downloadIcon from "../../Images/downloadIcon.png";
import "./Abha.css";

export default class Abharegister extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleSubmitAadhaar = (e) => {
    window.location.href = "/consentcollectionaadhaar";
  };
  handleSubmitMobile = (e) => {
    window.location.href = "/download";
  };
  handleSubmitVerifyMobile=()=>{
    window.location.href = "/abhaverificationflow";
    // window.location.href = "/abhanumberverification";

  }
  handleUpdateMobile=()=>{
    window.location.href = "/update";
  }
  render() {
    return (
      <div>
        <Row className="justify-content-evenly align-items-center createAbhaNumber " >
          
          <div  className="col-md-3">
            <div className="text-center card p-3 bg-light">
              <div className="card-body">
                <Image
                  src={Aadhaar}
                  alt=""
                  style={{
                    width: "auto",
                    height: "80px",
                  }}
                />
                <p>Create your ABHA Card</p>
                <Button className="rounded-0" onClick={this.handleSubmitAadhaar}>
                  Click Here
                </Button>
              </div>
            </div>
          </div>
          {/* <div className="col-md-3"> 
            <div className="text-center card p-3 bg-light">          
              <div className="card-body">
                <Image
                  src={Mobile}
                  alt=""
                  style={{
                    width: "auto",
                    height: "80px",
                  }}
                />
                <p>Verifiy Your ABHA Card</p>
                <Button className="rounded-0" onClick={this.handleSubmitVerifyMobile}>
                  Click Here
                </Button>
                </div>
            </div>
          </div>   */}
          <div className="col-md-3"> 
            <div className="text-center card p-3 bg-light">         
              <div className="card-body">
              <Image
                src={updateIcon}
                alt=""
                style={{
                  width: "auto",
                  height: "80px",
                }}
              />
              <p>Update Your ABHA Card</p>
              <Button className="rounded-0" onClick={this.handleUpdateMobile}>
                Click Here
              </Button>
              </div>
            </div>
          </div>
          <div className="col-md-3"> 
            <div className="text-center card p-3 bg-light">         
              <div className="card-body">
              <Image
                src={downloadIcon}
                alt=""
                style={{
                  width: "auto",
                  height: "80px",
                }}
              />
              <p>Verify / Download Your ABHA Card</p>
              <Button className="rounded-0" onClick={this.handleSubmitMobile}>
                Click Here
              </Button>
              </div>
            </div>
          </div>
        </Row>
      </div>
    );
  }
}
